import { render } from "./FeedbackScreen.vue?vue&type=template&id=45322241"
import script from "./FeedbackScreen.vue?vue&type=script&lang=js"
export * from "./FeedbackScreen.vue?vue&type=script&lang=js"

import "./FeedbackScreen.vue?vue&type=style&index=0&id=45322241&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__